import IconPlus from "./IconPlus.vue";
export default IconPlus